export const ZONE_WEBSERVICE_URL = 'https://geoloc.canal-overseas.com/geoip';
